















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ArgumentHandler from './ArgumentHandler.vue';

@Component({
  components: {
    ArgumentHandler,
  },
})
export default class Arguments extends Vue {
  @Prop() public args!: any[];
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValues!: any[];
  @Prop({ default: false }) public readonly actionVisible!: boolean;

  public getDefaultValue(index: number) {
    if (this.defaultValues) {
      try {
        return this.defaultValues[index].toJSON();
      } catch (e) {
        return this.defaultValues[index];
      }
    }
  }

  @Emit('selected')
  private selected(value: any) {
    return value;
  }

  @Emit('action')
  private action(value: any) {
    return value;
  } 

}
